import React, { FC, memo } from 'react'
import './index.scss'

// props
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
}

const ComponentContainer: FC<IProps> = ({ children, className, style }) => {
  return (
    <div
      className={`component ${className}`}
      style={style}
    >
      {
        children
      }
    </div>
  )
}

export default memo(ComponentContainer)
